/**
 * Minimal ULID generator for event/batch IDs without external deps.
 */
const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

function encodeTime(time: number, length = 10): string {
  let out = "";
  let value = time;
  for (let i = 0; i < length; i += 1) {
    const mod = value % 32;
    out = ENCODING[mod] + out;
    value = Math.floor(value / 32);
  }
  return out;
}

function getRandomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return bytes;
}

function encodeRandom(length = 16): string {
  const bytes = getRandomBytes(10);
  let buffer = 0;
  let bits = 0;
  let out = "";

  for (let i = 0; i < bytes.length; i += 1) {
    buffer = (buffer << 8) | bytes[i];
    bits += 8;
    while (bits >= 5) {
      bits -= 5;
      out += ENCODING[(buffer >> bits) & 31];
    }
  }

  if (bits > 0) {
    out += ENCODING[(buffer << (5 - bits)) & 31];
  }

  if (out.length < length) {
    out = out.padEnd(length, "0");
  }

  return out.slice(0, length);
}

export function ulid(): string {
  return `${encodeTime(Date.now())}${encodeRandom(16)}`;
}
